import React from "react";
import { Typography, Box } from "@material-ui/core";

export default function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      id={index}
      className={`${value !== index ? "hidden" : ""} min-h-0 pt-2 h-min`}
      {...other}
    >
      {children}
    </div>
  );
}
